// extracted by mini-css-extract-plugin
export default {"TitreEtBouton":"EntetePageOptions_TitreEtBouton__aMezy","BlocTitre":"EntetePageOptions_BlocTitre__IV21i"};